import React from 'react';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import PatientView from './components/PatientView';

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/:patientId" element={<PatientViewWrapper />} />
        <Route path="/" element={<div className="p-8 text-center">Please specify a patient ID in the URL (e.g., /1)</div>} />
      </Routes>
    </Router>
  );
}

function PatientViewWrapper() {
  const { patientId } = useParams();
  return <PatientView patientId={parseInt(patientId)} />;
}

export default App;

